var _style, _path, _rect, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9DCE1;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0478ED;}\n\t.st2{fill:#0478ED;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st4{fill:#56AAFF;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:none;stroke:#D9DCE1;stroke-width:1.8211;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#56AAFF;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#56AAFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#56AAFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#56AAFF;}\n\t.st11{fill:none;stroke:#0478ED;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#56AAFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#56AAFF;stroke-width:3;stroke-linecap:square;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44,8H20c-1.7,0-3,1.3-3,3v42c0,1.7,1.3,3,3,3h24c1.7,0,3-1.3,3-3V11C47,9.3,45.7,8,44,8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 33,
    width: 30,
    x: 17,
    y: 15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32,
    cy: 52,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 32,
    cy: 26,
    r: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41,38.8c0-1.1-0.3-2-0.9-2.9c-1.5-2.2-4.5-3.2-8.1-3.2c-3.5,0-6.6,0.9-8.1,3.2c-0.6,0.9-0.9,1.8-0.9,2.9  c0,1.5,0,2.2,0,2.2h18C41,41,41,40.4,41,38.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.20a97792a17b2f2d0e410a48c7b8c887.svg";
export { ForwardRef as ReactComponent };